export function getAllKeysOfEnum(e: Record<string | number, string | number>) {
  return Object.keys(e).filter((key) => isNaN(Number(key)));
}
